module.exports = __webpack_public_path__ + "static/img/1.9561fd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/1.png
// module id = VflE
// module chunks = 0